import { useMemo, useState } from 'react'
import Box from '@mui/material/Box'
import InputLabel from '@mui/material/InputLabel'
import FormControl from '@mui/material/FormControl'
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import { noop } from 'lodash'

/**
 * @typedef {import('../../../definitions').SelectOption} SelectOption
 */

/**
 * @typedef {Object} SelectOptionProps
 * @property {string} id
 * @property {SelectOption[]} options
 * @property {string=} selectLabel
 * @property {string} defaultValue
 * @property {function} onSelectOption
 */

/**
 * Select options.
 * @param {SelectOptionProps} props
 * @return {JSX.Element}
 */
export const SelectOptionControl = ({
  id,
  options = [],
  selectLabel,
  defaultValue,
  onSelectOption = noop,
}) => {
  const [optionValue, setOptionValue] = useState(defaultValue)

  /**
   * Handle option change.
   * @param {React.ChangeEvent<HTMLInputElement>} event
   */
  const handleChange = (event) => {
    const value = event.target?.value || ''
    if (!defaultValue) {
      setOptionValue(value)
    }

    onSelectOption(value)
  }

  const SelectOptions = useMemo(() => {
    return options.map((filterOption) => {
      const { label, value } = filterOption
      return (
        <MenuItem key={value} value={value}>
          {label}
        </MenuItem>
      )
    })
  }, [options])

  return (
    <Box sx={{ mb: 4, maxWidth: 200 }}>
      <FormControl fullWidth>
        {selectLabel && <InputLabel id={`select-option-${id}__label`}>{selectLabel}</InputLabel>}
        <Select
          labelId={`select-option-${id}__label`}
          label={selectLabel}
          id={`select-option-${id}-dropdown`}
          onChange={handleChange}
          value={defaultValue || optionValue}
        >
          {SelectOptions}
        </Select>
      </FormControl>
    </Box>
  )
}
